import useQuery from 'components/useQuery'
import { api } from 'api'
import { useEffect, useMemo } from 'react'
import { useToast } from '@chakra-ui/react'
import { isEmpty, orderBy } from 'lodash'

export const useFetchVersions = (appId) => {
  const toast = useToast()
  const {
    isError,
    isLoading,
    response,
    request,
    isSuccess,
    error,
  } = useQuery(() => api.admin.fetchVersions(appId))

  useEffect(() => {
    if (isError) {
      toast({
        title: 'Ошибка',
        description: error.response?.data?.errorText,
        status: 'error',
      })
    }
  }, [isError])

  const data = useMemo(() => {
    if (isEmpty(response?.list)) {
      return null
    }
    return orderBy(response?.list, ['appVersionNumber'], 'desc')
  }, [response?.list])

  return {
    fetchVersions: request,
    isLoadingFetchVersions: isLoading,
    isSuccessFetchVersions: isSuccess,
    dataVersions: data
  }
}
